import { Button, Drawer, Space } from 'antd';
import { drawerWidth750 } from '../../../utils/constants';
import { useTranslation } from 'react-i18next';
import { PlusCircleOutlined } from '@ant-design/icons';
import NewOrderItemForm from '../newOrderItenForm';

const NewOrderItem = ({ open, onClose, onNewItemSave }) => {
    const { t } = useTranslation();

    const saveData = async (values) => {
        onNewItemSave(values);
        onClose();
    }

    return (
        <Drawer
            title={t('order.newOrderItem')}
            width={drawerWidth750}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <Space className="drawerButtons">
                    <Button
                        form={'newOrderItem'}
                        icon={<PlusCircleOutlined />}
                        type="primary"
                        htmlType="submit"
                        key="submit"
                    >
                        {t('general.add')}</Button>

                    <Button key="close" onClick={onClose}>{t('general.cancel')}</Button>
                </Space>
            }
        >
            <NewOrderItemForm onFinish={saveData} />
        </Drawer>
    );
}
export default NewOrderItem;